// src/pages/OrganizerPage.jsx
import React from 'react';
import IntroImage from '../images/BAir-M_Bus-22_Single-09.jpg';

export default function OrganizerPage() {
  return (
    <article className="organizer-page">

    <section className="section-organizer jury-policy__intro">
        <h1 className="section-title">Организатор премии — Украинская Ассоциация Маркетинга (УАМ)</h1>
        <p className="jury-policy__subtitle">
          Украинская Ассоциация Маркетинга (УАМ) — это ведущая национальная и международно признанная профессиональная организация в сфере маркетинга, основанная в 1997 году. УАМ действует как некоммерческая общественная структура и зарегистрирована в соответствии с законодательством Украины (регистрационный номер 21708654). Организация объединяет более 3500 специалистов в области маркетинга, исследований, стратегических коммуникаций и преподавания, включая представителей крупнейших украинских и международных компаний.
        </p>
          <div className="jury-policy__intro-image">
          <img src={IntroImage} alt="Победители International CMO Summit Awards" />
        </div>
      </section>

      <section className="section-organizer">
        <h2>Международное признание</h2>
        <p>УАМ является официальным институциональным членом ESOMAR (European Society for Opinion and Marketing Research) и сотрудничает с American Marketing Association (AMA), принимая участие в разработке профессиональных стандартов и международных исследовательских инициатив. Представители УАМ регулярно участвуют в глобальных форумах (ESOMAR Congress, WARC Events, Marketing Summit Europe), представляя Украину на международной арене как авторитетного эксперта в сфере маркетинга и исследований.</p>
      </section>

      <section className="section-organizer">
        <h2>Профессиональная миссия и стандарты</h2>
        <p>УАМ занимается разработкой и внедрением отраслевых стандартов и этических кодексов, среди которых:</p>
        <ul className="organizer-list">
          <li>
            <strong>Quality Standards of Marketing Research</strong> (UMA-SOU 91.12.0-21708654-001-2002) — признаны на национальном уровне;
          </li>
          <li>
            <strong>Ethical Guidelines</strong> (SOU 21708654-002-2011) — соответствуют рекомендациям ESOMAR, ICC.
          </li>
        </ul>
        <p>
Ассоциация реализует программу профессиональной сертификации маркетологов, включающую экзамены, подготовительные курсы и строгую квалификационную аттестацию.
        </p>
      </section>

      <section className="section-organizer">
        <h2>Образовательная и исследовательская деятельность</h2>
        <p>УАМ организует десятки мероприятий ежегодно, включая:</p>
        <ul className="organizer-list">
          <li>Международный форум «Промышленный маркетинг»</li>
          <li>Национальные конференции «Дни интернет-маркетинга»</li>
          <li>Семинары, тренинги и хакатоны по аналитике, брендингу и коммуникациям</li>
        </ul>
        <p>Ассоциация издает профессиональный журнал Marketing in Ukraine, проводит независимые маркетинговые исследования и поддерживает национальную библиотеку по маркетингу. Общий охват образовательных проектов превышает 25 000 участников ежегодно.</p>
      </section>



      <section className="section-organizer">
        <h2>Организация международных конкурсов</h2>
        <p>
          С 2019 года УАМ является официальным организатором премии International CMO Summit Awards — одного из крупнейших конкурсов в Восточной Европе для директоров по маркетингу и коммуникациям. В конкурсе ежегодно участвуют более 300 кандидатов 20+ стран, охватывая СНГ, Центральную Азию, Восточную Европу и Ближний Восток.
        </p>
        <p>Победители получают признание от международного жюри, в состав которого входят эксперты из ESOMAR, Cannes Lions, WARC, McKinsey и других структур.</p>
      </section>

      <section className="section-organizer">
        <h2>Партнёрства и социальная миссия</h2>
        <p>УАМ активно сотрудничает с:</p>
        <ul className="organizer-list">
          <li>Министерство образования и науки Украины</li>
          <li>Государственная служба статистики</li>
          <li>Национальная палата предпринимателей</li>
          <li>Международные ассоциации и университеты</li>
        </ul>
        <p>
Ассоциация реализует проекты по поддержке внутренне перемещённых лиц, развитию ESG-коммуникаций, гендерному равенству в рекламе, а также защите прав потребителей и цифровой грамотности населения.
        </p>
      </section>

                  {/* <section className="banner-block">
        <div className="banner-content">
<h2>Организация международных конкурсов</h2>
        <p>          С 2019 года УАМ организует International CMO Summit Awards — один из крупнейших конкурсов в Восточной Европе
          для директоров по маркетингу и коммуникациям. Ежегодно более 300 кандидатов из 20+ стран, включая СНГ,
          ЦА, ВЕ и Ближний Восток.</p>
        </div>
      </section> */}
    </article>
);
}
